import { Component } from '@angular/core';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-modal-detalhe-beneficio',
  templateUrl: './modal-detalhe-beneficio.component.html',
  styleUrls: ['./modal-detalhe-beneficio.component.css']
})
export class ModalDetalheBeneficioComponent {
  //Icones
  faPrint = faPrint;
  beneficio: any;
  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) { }
  downloadFile(base64Data: string, fileName: string) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
  }
}
